import { Row, Col, Image } from 'react-bootstrap';
import { getWindowDimension } from 'common/utils';
import {
  CarouselProvider,
  Slider,
  Slide,
  DotGroup,
  Dot,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel';
import { TestimonialCard } from 'components/Testimonials/TestimonyCard';
import { TESTIMONIALS } from 'components/Testimonials/constants';
import { IMAGES } from 'common/images';
import 'pure-react-carousel/dist/react-carousel.es.css';
import 'components/Testimonials/index.scss';

const getVisibleSlides = () => {
  const { width } = getWindowDimension();
  if (width <= 767.98) return 1.25;

  if (width <= 1199.98) return 2.3;

  if (width >= 1900) {
    return 3.5;
  }

  return 2.8;
};

const renderDots = (props) => {
  const { totalSlides, currentSlide } = props;

  return (
    <div>
      {new Array(totalSlides).fill(0).map((_, index) => (
        <Dot slide={index} className="dot-holder">
          <div className={`${index === Math.ceil(currentSlide) ? 'dot-selected' : 'dot'}`} />
        </Dot>
      ))}
    </div>
  );
};

const renderHeader = () => {
  if (getWindowDimension().width <= 767.98) {
    return (
      <p className="testimonials__title">
        MADE FOR <span>TEENS</span>.<br />
        LOVED BY <span>PARENTS</span>
      </p>
    );
  }
  return (
    <p className="testimonials__title">
      MADE FOR <span>TEENS</span>. LOVED BY <span>PARENTS</span>
    </p>
  );
};

export const Testimonials = () => (
  <Row className="testimonials">
    <Col className="no-pad text-center">
      {renderHeader()}
      <CarouselProvider
        isPlaying
        infinite
        lockOnWindowScroll
        isIntrinsicHeight
        interval={2000}
        totalSlides={6}
        visibleSlides={getVisibleSlides()}
      >
        <Slider className="pb-5">
          {TESTIMONIALS.map(({ designation, apple, name, testimony, image }, index) => (
            <Slide key={name} index={index} className="slider">
              <TestimonialCard
                designation={designation}
                apple={apple}
                name={name}
                testimony={testimony}
                image={image}
              />
            </Slide>
          ))}
        </Slider>
        <Row noGutters className="justify-content-between align-items-center mx-2">
          <ButtonBack className="testimonials__arrow">
            <Image src={IMAGES.ArrowLeft} alt="arrow-left" className="testimonials__arrow__img" />
          </ButtonBack>
          <DotGroup renderDots={renderDots} />
          <ButtonNext className="testimonials__arrow">
            <Image src={IMAGES.ArrowRight} alt="arrow-right" className="testimonials__arrow__img" />
          </ButtonNext>
        </Row>
      </CarouselProvider>
    </Col>
  </Row>
);
